import React from 'react';
import ContentBaseLayout from '../shared/ContentBaseLayout';
import NoElementsFound from '../../../shared/components/NoElementsFound';
import { Redirect, useLocation, useParams } from 'react-router';
import { useLocalRegions } from '../../../api/local-content/marketplace/local-regions/useLocalRegions';
import { ageCategoryFromString } from '../../../../models/AgeCategory';
import { useQueryParams } from '../../../shared/hooks/useQueryParams';
import { LoadingWrapper } from '../../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';

export const LocalRegionsRedirect = () => {
    const { pathname } = useLocation();

    const { shopLanguage } = useParams<{ shopLanguage?: string }>();

    const {
        ageCategory: { value: ageCategoryQueryParam }
    } = useQueryParams({
        ageCategory: 'string'
    });

    const ageCategory = ageCategoryFromString(ageCategoryQueryParam);

    const { localRegions, isLoading: isLocalRegionsLoading } = useLocalRegions(ageCategory, shopLanguage);

    if (isLocalRegionsLoading) {
        return (
            <LoadingWrapper>
                <LoadingOverlay loading={true} />
            </LoadingWrapper>
        );
    }

    if (localRegions.length > 0) {
        return <Redirect to={`${pathname}/${localRegions[0].name}`} />;
    }

    return (
        <ContentBaseLayout documentTitle="Local Regions" contentComponent={<NoElementsFound type="localRegions" />} />
    );
};
